//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  transition: {
    name: 'jade',
    mode: 'out-in'
  },
  async asyncData ({ $storyapi, error, route }) {
    try {
      const fullSlug =
        route.path === '/' || route.path === '' ? 'home' : route.path

      const payload = {
        resolve_links: 'url',
        cv: new Date().getTime(),
        resolve_relations: ['Inn.categories'],
        version: process?.env?.APP_ENV !== 'production' ? 'draft' : 'published'
      }

      const currentPage = await $storyapi.getStory(fullSlug, payload)

      return { childStory: currentPage.data.story }
    } catch (e) {
      // console.error('Exception', e)
      error({
        statusCode: 404,
        message: e.message
      })
    }
  },
  computed: {
    title () {
      return this.childStory?.content?.title || ''
    },
    description () {
      return this.childStory?.content?.description || ''
    },
    featuredImage () {
      return this.childStory?.content?.featuredImage || { filename: '' }
    },
    categories () {
      return this.childStory?.content?.categories || []
    },
    address () {
      return this.childStory?.content?.address || ''
    },
    phone () {
      return this.childStory?.content?.phone || ''
    },
    website () {
      return this.childStory?.content?.website || ''
    },
    menu () {
      if (!this.childStory?.content?.lunchMenu) { return '' }
      return this.childStory?.content?.menuLink || ''
    },
    openingHoursGeneral () {
      return this.childStory?.content?.openingHoursGeneral?.days || []
    },
    openingHoursWarmFood () {
      return this.childStory?.content?.openingHoursWarmFood?.days || []
    },
    hasWarmFood () {
      return !!this.openingHoursWarmFood.reduce((p, c) => {
        p.push(...c.times)
        return p
      }, []).filter(time => time.start && time.end).length
    },
    dayOff () {
      return this.childStory?.content?.dayOff || ''
    },
    joinedCategories () {
      if (!this.categories || !Array.isArray(this.categories)) { return '' }
      return this.categories.map(category => category.content?.title || '').filter(Boolean).join(', ')
    },
    pickupPossible () {
      return this.childStory?.content?.pickupPossible || false
    },
    recommendedReservationTime () {
      return this.childStory?.content?.recommendedReservationTime || ''
    }
  },
  mounted () {
    this.$nextTick(() => {
      document.getElementsByTagName('body')[0].classList.add('overflow-hidden')
      window.addEventListener('keydown', this.keyHandler)
    })
  },
  beforeDestroy () {
    document.getElementsByTagName('body')[0].classList.remove('overflow-hidden')
    window.removeEventListener('keydown', this.keyHandler)
  },
  methods: {
    keyHandler (event) {
      if (event.key === 'Escape') {
        this.$router.push({ name: 'index', query: this.$route.query })
      }
    },
    handleOverlayClick () {
      this.$router.push({ name: 'index', query: this.$route.query })
    }
  }
}
